import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { PublicUserData } from 'src/shared/features/users/schemas/user'

export const getUserByUsername = (username: string) => getRequest<PublicUserData>(`/users/lookup?username=${username}`)

export const useUserByUsername = (username: string) => {
  return useSuspenseQuery({
    ...queries.users.detailByUsername(username),
    queryFn: () => (!username ? null : getUserByUsername(username)),
    staleTime: 15 * 60 * 1000,
    retry: false,
  })
}

export const useUserByUsernameQuery = (username?: string) => {
  return useQuery({
    ...queries.users.detailByUsername(username || ''),
    queryFn: () => (!username ? null : getUserByUsername(username)),
    staleTime: 15 * 60 * 1000,
    retry: false,
    enabled: username !== undefined,
  })
}

export const useCheckForUser = (username: string) => {
  return useQuery({
    ...queries.users.detailByUsername(username),
    queryFn: () => (!username ? null : getUserByUsername(username)),
    staleTime: 15 * 60 * 1000,
    retry: false,
  })
}
